<template>
  <ExternalQueryList
      headline="Reminders"
      endpoint="/api/v2/reminders"
      :endpoint-filters="{project_id: project.id}"
      :headlines="headlines"
      :filters="filters"
      :checkbox-column-width="2"
      :button-column-width="2"
      :can-show="() => false"
      :can-destroy="() => false"
  >
    <template v-slot:default="{ row: reminder }">
      <td class="table__ellipsis">
        <router-link :to="'/'+ reminder.attributes.subject_type + '/' +reminder.attributes.subject_id">
          {{ reminder.attributes.subject_name }}
        </router-link>
      </td>

      <td class="table__ellipsis">
        {{ reminder.attributes.text }}
      </td>

      <td>
        <span v-if="reminder.attributes.priority === 'high'" class="label label-danger">
          High
        </span>

        <span v-if="reminder.attributes.priority === 'medium'" class="label label-warning">
          Medium
        </span>

        <span v-if="reminder.attributes.priority === 'low'" class="label label-success">
          Low
        </span>
      </td>

      <td>
        <span v-if="reminder.attributes.resolved_at" class="label label-success">
          Resolved
        </span>

        <span v-else class="label label-warning">
          Unresolved
        </span>
      </td>

      <td class="table__ellipsis">
        <Avatar :color="reminder.attributes.user_color">
          {{ reminder.attributes.user_initials }}
        </Avatar>
      </td>

      <td class="table__ellipsis">
        {{ reminder.attributes.remind_at | date }}
      </td>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'
import Avatar from "../../../Avatar.vue";

export default {
  components: {Avatar, ExternalQueryList},

  props: {
    project: {
      required: true
    },

    users: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 4, text: 'Subject'},
        {width: 4, text: 'Text'},
        {width: 3, text: 'Priority', sort_column: 'priority'},
        {width: 3, text: 'Status'},
        {width: 3, text: 'User'},
        {width: 3, text: 'Remind Date', sort_column: 'remind_at'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 6,
            widget: 'select',
            name: 'user_id',
            options: this.users.map(user => ({value: user.id, label: user.attributes.full_name})),
            nullable: true,
            placeholder: '(all users)'
          },
          {
            width: 6,
            widget: 'select',
            name: 'priority',
            options: [
              {value: 'low', label: 'Low'},
              {value: 'medium', label: 'Medium'},
              {value: 'high', label: 'High'},
            ],
            nullable: true,
            placeholder: '(all priorities)'
          },
          {
            width: 6,
            widget: 'select',
            name: 'status',
            options: [{value: 'resolved', label: 'Resolved'}, {value: 'unresolved', label: 'Unresolved'}],
            nullable: true,
            placeholder: '(all statuses)'
          },
          {
            width: 6,
            widget: 'submit'
          }
        ]
      ]
    }
  }
}
</script>
